import { useMutation } from "@tanstack/react-query";

import http from "../../../http";
import { NONINDEXED_FILING } from "../../URL";
import { IFeeCalculationRequest } from "../../../interfaces";

interface IAxisErrorResponse {
  response?: {
    data?: string;
  };
}

const nonIndexedFiling = async (filing: IFeeCalculationRequest) => {
  const response = await http.post<number>(NONINDEXED_FILING, filing);
  return response?.data;
};

const useNonIndexedFiling = () =>
  useMutation<number, IAxisErrorResponse, IFeeCalculationRequest>({
    mutationKey: ["subsequent-filing"],
    mutationFn: nonIndexedFiling,
  });

export default useNonIndexedFiling;
